<template>
  <div>
    <b-navbar type="dark" class="nav-contact-box" style="background: var(--nav-bg);" >
      <div class="d-flex mx-auto container-box">
        <div class="align-items-center d-flex flex-grow-1">
          <b-navbar-brand href="mailto:index_jie@163.com">
            <b-icon class="mr-1 svg-icon" icon="envelope"></b-icon>
            <b-link :href="'mailto:'+getConfig.mail" class="default-text" >{{getConfig.mail}}</b-link>
          </b-navbar-brand>
          <b-navbar-brand href="tel:8613365856402">
            <i class="mr-1 svg-icon icon-telphone" ></i>
            <b-link :href="'tel:'+getConfig.phone" class="default-text" >{{getConfig.phone}}</b-link>
          </b-navbar-brand>
        </div>
      </div>
    </b-navbar>


    <b-navbar type="dark" class="nav-header" style="position: sticky;top: 0;z-index: 10" >
      <div class="d-flex mx-auto container-box align-items-center">
        <div class="align-items-center d-flex">
          <b-navbar-brand to="/">
            <b-img class="header-logo" :src="getFileAccessHttpUrl(getConfig.logo)"></b-img>
          </b-navbar-brand>
        </div>
        <div class="d-flex">
          <b-navbar-nav class="search-box" href="#">
            <b-form-input @keyup.enter="search" class="search-box-inp" v-model="proName" placeholder="Enter part number or keyword"></b-form-input>
            <b-button @click="search" size="sm" class="search-box-btn" style="line-height: 31px;"><b-icon icon="search"></b-icon></b-button>
          </b-navbar-nav>
        </div>
<!--        <b-navbar-brand class="align-items-center d-flex shopping-box text-black-50 shopping-box" href="#">
          <b-icon icon="display-fill" style="color: #0070ba"></b-icon>&nbsp;
          <span style="font-weight: normal;">0&nbsp;item&nbsp;(s)</span>
        </b-navbar-brand>-->
      </div>
    </b-navbar>
    <b-navbar type="dark" class="nav-menu" >
      <div class="d-flex mx-auto container-box">
        <div class="align-items-center d-flex flex-fill ">

          <b-navbar-brand tag="div" class="default-text pro-hover" to="/category" >
            <b-icon font-scale="1.5" style="margin-right: 8px;fill:#fff;font-size: 150% !important;" icon="blockquote-right" ></b-icon>All Products
            <div class="cate-menu-position" v-if="routeName !== 'home'">
              <categoryMenuList></categoryMenuList>
            </div>
          </b-navbar-brand>

          <b-navbar-brand class="default-text" to="/noticeItem/1" title="Component Technologies">Component Technologies</b-navbar-brand>
          <b-navbar-brand class="default-text" to="/aboutUs" title="About Us">About Us</b-navbar-brand>
          <b-navbar-brand class="default-text" to="/manufacturer" title="Manufacturer">Manufacturer</b-navbar-brand>
          <b-navbar-brand class="default-text" to="/support" title="support">Support</b-navbar-brand>
<!--          <b-dropdown-hover style="font-weight: bold" to="/support" class="header-select default-text" id="dropdown-1" text="Support">
            <b-dropdown-item>Delivery Services</b-dropdown-item>
            <b-dropdown-item>Payment Methods</b-dropdown-item>
            <b-dropdown-item>Terms & Conditions</b-dropdown-item>
            <b-dropdown-item>Privacy Policy</b-dropdown-item>
          </b-dropdown-hover>-->

          <b-navbar-brand class="default-text" to="/qualityControl" title="Quality Control">Quality Control</b-navbar-brand>
          <b-navbar-brand class="default-text" to="/noticeItem/0" title="News">News</b-navbar-brand>
          <b-navbar-brand class="default-text" to="/contactUs" title="Contact Us">Contact Us</b-navbar-brand>
        </div>
        <b-navbar-nav>
          <b-link to="/inquiry">
            <button class="shopping-btn border-0"><b-icon icon="chat-square-text-fill"></b-icon> &nbsp;RFQ Inquiry</button>
          </b-link>
        </b-navbar-nav>
      </div>
    </b-navbar>
  </div>

</template>
<script>
import categoryMenuList from "@/components/CategoryMenuList.vue";
import {EventBus} from "@/utils/eventBus";
import {getFileAccessHttpUrl} from "@api/manage";
import {mapGetters} from "vuex";

export default {
  components:{
    categoryMenuList
  },
  data(){
    return{
      routeName:'',
      proName:'',
      logo:'',
      phone:'',
      mail:''
    }
  },
  created() {
    this.routeName = this.$route.name
    // this.getSetiing();
  },
  computed:{
    ...mapGetters(['getConfig'])
  },
  watch: {
    '$route'(to, from) {
      this.routeName = to.name;
    }
  },
  methods:{
    getFileAccessHttpUrl,
    search(){
      this.$router.push({ path: '/productItem/search', query: { proName:this.proName } });
      EventBus.$emit("search")
    }
  }
}
</script>

<style lang="scss">
#dropdown-1{
  button{
    background: #ff000000;
    border: none;
    &:active{
      border: none;
    }
  }
}
.icon-xuanpan {
  background: url('/imgs/xunpan.png');
  background-size: cover;
  background-repeat: no-repeat;
  padding-left: 10px;
  padding-right: 10px;
}
.header-select{

}
.pro-hover:hover .cate-menu-position{
  display: block !important;
}

.cate-menu-position{
  position: absolute;
  display: none !important;
  padding-top: 22px;
}
.breadcrumb-font{
  font-size: 13px;
}
.nav-menu .navbar-brand{
  margin-right: 2rem;
}
.svg-icon+a{
  font-weight: 500 !important;
  color: #242e3e;
}
.search-box-inp::-webkit-input-placeholder {
  /* WebKit browsers，webkit内核浏览器 */
  color: #959fb5;
  font-size: 13px;
}
.search-box-inp:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #959fb5;
  font-size: 13px;
}
.search-box-inp::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #959fb5;
  font-size: 13px;
}
.search-box-inp:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #959fb5;
  font-size: 13px;
}


.search-box{
  height: 40px;
  width: 700px;
  margin-left: 187px;
}
.search-box-inp{
  height: 100%;
  display: block;
  width: 100% !important;
  font-size: 14px;
  outline: 0;
  background: #fff;
  border: 1px solid var(--primary-color);
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  padding-left: 20px;
  padding-right: 60px;
}
.search-box-btn{
  width: 54px;
  border: 0;
  margin-left: -6px;
  margin-right: -2px;
  border-radius: 0 6px 6px 0;
  background: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}
.shopping-btn{
  cursor:pointer;
  text-align: center;
  width: 134px;
  height: 40px;
  border-radius: 8px;
  font-weight: 600;
  color: var(--primary-color);
  background-color: white !important;
}


.nav-header{
  //background-color: #e7f2fa;
  background-color: var(--primary-secondary-color);
}
.nav-menu{
  background-color: var(--primary-color);
}
.header-logo{
  max-width: 100%;
  max-height: 56px;
}
.nav-contact-box {
  height: 40px;
}
.nav-contact-box a{
  color: var(--main-text-color) !important;
}
.nav-contact-box a svg{
  margin-right: 4px;
  color: #b0b7c8;
  font-size: 18px;
}

.svg-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
}
</style>
